import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export default reduxFetch([
  {
    resource: `identitiesComplete`,
    method: 'get',
    request: filters => ({
      url: addParametersToUri(apiRoutes.identities(), filters),
      clearValueOnRequest: true,
    }),
  },
]);
